import React,{ Component } from 'react';
import {
  connect
} from 'react-redux';
import {
  getAvailablePolicyTypes
} from 'reducers/config';
import {
  Field,
  reduxForm
} from 'redux-form';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import {
  underscoreToTitleCase
} from 'utils/strings';
import styles from './styles';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  name,
  children,
  ...custom
}) => (
  <TextField
    label={label}
    {...input}
    {...custom}
    FormHelperTextProps={{
      error: touched && !!error
    }}
    helperText={touched && error}
    fullWidth={true}
    className="query--form-field"
  >
    {children}
  </TextField>
);

const validate = values => {
  let errors = {};

  if (!values.policy_type) {
    errors.policy_type = 'Required';
  }

  if (values.customer_number) {
    if (values.customer_number.length < 2) {
      errors.customer_number = 'Must be 2 characters or more';
    } else if (!values.customer_number.length > 20) {
      errors.customer_number = 'Must be 20 characters or less';
    }
  }

  if (values.phone_number) {
    if (!/^0[0-9]{9,}$/.test(values.phone_number)) {
      errors.phone_number = 'Invalid';
    }
  }

  if (values.post_code) {
    if (!/^[a-zA-Z0-9 ]+$/.test(values.post_code)) {
      errors.post_code = 'Invalid';
    }
  }

  if (values.customer_name) {
    if (values.customer_name.length < 2) {
      errors.customer_name = 'Must be 2 characters or more';
    } else if (!values.customer_name.length > 50) {
      errors.customer_name = 'Must be 50 characters or less';
    }
  }

  if (!values.customer_number) {
    let filtered = [
      values.phone_number || false,
      values.post_code || false,
      values.customer_name || false
    ].filter(value => value !== false);

    if (filtered.length < 2) {
      errors.customer_number = 'Either the Customer Number or 2 other options must be entered';
    }
  }

  return errors;
};

class QueryForm extends Component {
  render() {
    const {
      handleSubmit,
      policyTypes,
      classes
    } = this.props;

    let PolicyTypeOptions = policyTypes.map(policyType => (
      <option key={policyType} value={policyType}>
        {underscoreToTitleCase(policyType)}
      </option>
    ));

    if (policyTypes.length > 1) {
      PolicyTypeOptions.unshift(<option key="none" />);
    }

    return (
      <Paper className={classNames(classes.paper)}>
        <form
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <Grid container spacing={16}>
            <Grid item xs={12}>
              <Field
                select
                name="policy_type"
                label="Policy Type"
                SelectProps={{
                  native: true
                }}
                component={renderTextField}
                children={PolicyTypeOptions}
              />
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <Field
                name="customer_number"
                label="Customer Number"
                component={renderTextField}
              />
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <Field
                name="phone_number"
                label="Phone Number"
                component={renderTextField}
              />
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <Field
                name="post_code"
                label="Post Code"
                component={renderTextField}
              />
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <Field
                name="customer_name"
                label="Last Name"
                component={renderTextField}
              />
            </Grid>
            <Grid item xs={12} style={{
              textAlign: 'right'
            }}>
              <Button
                color="primary"
                variant="outlined"
                type="submit"
                fullWidth
              >
                Search
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    )
  }
}

const mapStateToProps = state => ({
  policyTypes: getAvailablePolicyTypes(state.config),
  initialValues: {
    policy_type: 1 === getAvailablePolicyTypes(state.config).length ? getAvailablePolicyTypes(state.config)[0] : null,
  }
});

export default withStyles(styles)(connect(mapStateToProps)(reduxForm({
  form: 'coverage/query',
  validate
})(QueryForm)));




// WEBPACK FOOTER //
// ./src/components/Query/QueryForm.js